import noop from 'lodash/noop';
import { FunctionComponent } from 'react';
import { Close16 } from 'ui/icons';
import { GhostButton } from 'ui/button';
import { InputText, INPUT_TEXT_TYPES } from 'ui/inputs';
import { SplitItem } from './SplitEditor.style';
import { getSplitInputTestId, getSplitRemoveTestId } from './testUtils';

type SplitInputProps = {
  itemIndex?: number;
  value: string;
  isDisabled?: boolean;
  onChange?: (value: string, index: number) => void;
  splitEditor: string;
  hasError?: boolean;
  showRemove: boolean;
  onRemove?: (index: number) => void;
  inputType?: any;
  suffix?: string;
  className?: string;
  placeholder?: string;
};

export const SplitInput: FunctionComponent<React.PropsWithChildren<SplitInputProps>> = ({
  itemIndex = 0,
  value,
  isDisabled = false,
  onChange = noop,
  splitEditor,
  hasError = false,
  showRemove,
  onRemove = noop,
  inputType = undefined,
  suffix,
  className,
  placeholder,
}) => (
  <SplitItem className={className}>
    <InputText
      id={`split-input-${itemIndex}`}
      isDisabled={isDisabled}
      type={inputType}
      value={value}
      Suffix={suffix}
      onChange={(val) => onChange(val, itemIndex)}
      data-test={getSplitInputTestId(splitEditor, itemIndex)}
      hasError={hasError}
      placeholder={placeholder}
    />

    {!isDisabled && showRemove && (
      <GhostButton
        onClick={() => onRemove(itemIndex)}
        data-test={getSplitRemoveTestId(splitEditor, itemIndex)}
      >
        <Close16 />
      </GhostButton>
    )}
  </SplitItem>
);

export const SplitNumberInput: FunctionComponent<React.PropsWithChildren<SplitInputProps>> = (
  props,
) => <SplitInput {...props} inputType={INPUT_TEXT_TYPES.NUMBER} />;
export const SplitPercentageInput: FunctionComponent<React.PropsWithChildren<SplitInputProps>> = (
  props,
) => <SplitNumberInput {...props} suffix="%" />;
